import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { motion } from 'framer-motion';
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: nowrap;\n  position: relative;\n"], ["\n  display: flex;\n  flex-wrap: nowrap;\n  position: relative;\n"])));
export var DownArrow = styled(motion.div)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  top: 5px;\n  left: -1px;\n"], ["\n  position: relative;\n  top: 5px;\n  left: -1px;\n"])));
var templateObject_1, templateObject_2;
